import { Trans } from '@lingui/react';

import AdminToolbar, {
  AdminButton,
} from '@rover/react-lib/src/components/AdminToolbar/AdminToolbar';
import useLocationContext from '@rover/react-lib/src/context/useLocationContext';
import { useApiPublicTrainerProfileRetrieve } from '@rover/rsdk/src/apiClient/latest';

const getSlugFromPathname = (path: string): string => {
  const matcher = /\/training\/members\/(?<slug>[\w-]+)/;
  return path.match(matcher)?.groups?.slug || '';
};

const TrainerProfileAdminToolbar = (): JSX.Element => {
  const location = useLocationContext();
  const { pathname } = location;

  const personSlug = getSlugFromPathname(pathname);
  const { data: personTrainerProfile } = useApiPublicTrainerProfileRetrieve(personSlug);
  const personOpk = personTrainerProfile?.opk;

  const trainerProfileUrl = `/admin/training/trainerprofile/?provider_opk=${personOpk}`;
  const personUrl = `/admin/people/person/?opk=${personOpk}`;
  const impersonationUrl = `/admin/people/person/become_person/${personOpk}/?next=${pathname}`;

  const firstName = personTrainerProfile?.shortName.split(' ')[0];

  return (
    <AdminToolbar>
      <AdminButton href={trainerProfileUrl}>
        <Trans id="View Trainer Profile" />
      </AdminButton>
      <AdminButton href={personUrl}>
        <Trans id="View in People" />
      </AdminButton>
      <AdminButton href={impersonationUrl}>
        <Trans id={`Login as ${firstName}`} />
      </AdminButton>
    </AdminToolbar>
  );
};

export default TrainerProfileAdminToolbar;
